import error from "@/store/modules/error";

const modules = {
  error
};

export default modules;
